export default {
  downloadButtonLabel: 'Download',
  cancelButtonLabel: 'Cancel',
  inputPlaceholder_endDate: 'End Date',
  inputPlaceholder_startDate: 'Start Date',
};